import ImageConverter from "../../utils/convert/ImageConverter";
import { IllustrationApi } from "../ServerResponseType/Illustration/Illustration";
import { ImageDTOApi } from "./ImageDTO";

export default class IllustrationImageDTO implements ImageDTOApi {
  protected _imageData: IllustrationApi;

  constructor(imageData: IllustrationApi) {
    this._imageData = imageData;
  }

  get imageId(): string {
    return this._imageData.illustrationId;
  }

  get imageData(): string | File {
    return this._imageData.illustration;
  }

  get imageSrc(): string {
    let illustration = this._imageData.illustration;
    if (typeof illustration === "string")
      return ImageConverter.AddConfigStringBeforeImageDataString(illustration, this._imageData.illustrationType);
    else return URL.createObjectURL(illustration);
  }
}

export class IllustrationImageDTOWithNameAndAuthor extends IllustrationImageDTO {
  constructor(imageData: IllustrationApi) {
    super(imageData);
  }

  get illustrationName(): string | undefined {
    return this._imageData.illustrationName;
  }

  get illustrationAuthor(): string | undefined {
    return this._imageData.illustrationAuthor;
  }
}
